import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import EventCard from "./EventCard";
import EventDetailCard from "./EventDetailCard";
import EventSkillOverviewTable from "../event/EventSkillOverviewTable";
import { AdminApi } from "../../api/AdminApi";
import { is } from "date-fns/locale";


let mockMemberResultData = [
  {
    "member_id": 29113,
    "group": "1A",
    "group_num": "01",
    "display_name": "Annie Fu",
    "total_rank_score": 10,
    "is_completed": true,
    "skill_data": [
      {
        "skill_code": "fit_situp",
        "rank": 5,
        "rank_score": 5,
        "skill_score": 30
      },
      {
        "skill_code": "fit_sitnreach",
        "rank": 2,
        "rank_score": 2,
        "skill_score": 20
      },
      {
        "skill_code": "fit_15mrun",
        "rank": 1,
        "rank_score": 1,
        "skill_score": 7
      },
      {
        "skill_code": "fit_handgrip",
        "rank": 2,
        "rank_score": 2,
        "skill_score": 15
      }
    ]
  },
  {
    "member_id": 29114,
    "group": "1B",
    "group_num": "002",
    "display_name": "Sam Wong",
    "total_rank_score": 0,
    "is_completed": false,
    "skill_data": []
  }
]

let skillInfoList = [
  {
    "skill_code": "fit_situp",
    "skill_name_en": "1 min Sit-up",
    "skill_name_zh": "體適能 - 1分鐘仰臥起坐",
    "display_name": "體適能 - 1分鐘仰臥起坐",
    "unit": "time"
  },
  {
    "skill_code": "fit_sitnreach",
    "skill_name_en": "Sit and Reach",
    "skill_name_zh": "體適能 - 坐前伸",
    "display_name": "體適能 - 坐前伸",
    "unit": "cm"
  },
  {
    "skill_code": "fit_15mrun",
    "skill_name_en": "15m run",
    "skill_name_zh": "15米漸進式心肺耐力跑",
    "display_name": "15米漸進式心肺耐力跑",
    "unit": "round"
  },
  {
    "skill_code": "fit_handgrip",
    "skill_name_en": "Hand Grip",
    "skill_name_zh": "手握力",
    "display_name": "手握力",
    "unit": "kg"
  },
  {
    "skill_code": "fit_squat",
    "skill_name_en": "Squat",
    "skill_name_zh": "深蹲",
    "display_name": "深蹲",
    "unit": "kg"
  }
]

export default function EventScoreOverviewSection({ event }) {
  const [skillInfoList, setSkillInfoList] = useState(null);
  const [memberResultData, setMemberResultData] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const eventID = event.id;

  // const isReady = (skillInfoList != null) && (memberResultData != null);

  React.useEffect(() => {
    AdminApi.getEventParticipantOverviewCallback(eventID,
      (isSuccess, msg, result) => {
        console.debug("getEventParticipantOverviewCallback: ", result);
        if (isSuccess) {
          setMemberResultData(result.member_result);
          setSkillInfoList(result.skill_list);
          setIsReady(true);
        }
        // console.debug("result: isSuccess=", isSuccess,
        //   " msg=", msg, " result=", result);
      }
    );
  }, []);

  if (isReady === false) {
    return (
      <Typography variant="h6" align="center" sx={{ py: 3 }} >Loading...</Typography>
    );
  }


  return (
    <EventSkillOverviewTable skillList={skillInfoList} memberResultData={memberResultData} />
  );
}
